import React from 'react';
import 'intersection-observer';

class LazyImage extends React.Component {
	constructor(props) {
		super(props);

        this.image = React.createRef();
        // this.placeholder = React.createRef();

		// this.placeholderImage = null;
        this.lazyImage = null;
        this.lazyImagesObserver = null;
		this.state = {
            loading: false,
			loaded: false
		};
	}

	componentDidMount() {
		// if(!this.state.loaded) {
  //           this.preload();
  //       }
  //       else {
  //           console.log('IMAGE ALREADY LOADED', this.props.attrs.src);
  //       }

        this.lazyImagesObserver = new IntersectionObserver((entries, observer) => {
            // console.log('entries', entries);
            entries.forEach((entry) => {
                if(entry.isIntersecting) {
                    this.preload();
                    this.lazyImagesObserver.unobserve(entry.target);
                    this.lazyImagesObserver.disconnect();
                }
            });
        }, {
            threshold: 0,
            rootMargin: '0px 0px 450px 0px'
        });

        this.lazyImagesObserver.observe(this.props.forwardedRef.current);
	}

	componentWillUnmount() {
		if(this.lazyImage) {
			this.lazyImage.onload = null;
            this.lazyImage = null;
		}

        if(this.lazyImagesObserver) {
            this.lazyImagesObserver.unobserve(this.props.forwardedRef.current)
        }
	}

	componentDidUpdate(prevProps, prevState) {
		
	}

	preload() {
        if(!this.state.loaded) {
            this.setState({
                loading: true
            });

    		let { srcSet, sizes } = this.props.attrs;

    		this.lazyImage = new Image();
    		this.lazyImage.onload = this.onLoadEnd.bind(this);
    		
            if(sizes) this.lazyImage.setAttribute('sizes', sizes);
            if(srcSet) this.lazyImage.setAttribute('srcset', srcSet);
    		
            // this.lazyImage.setAttribute('src', this.props.attrs.src);

            // if(this.lazyImage.complete && this.lazyImage.naturalWidth) {
            //     this.onLoadEnd();
            // }
        }
	}

	onLoadEnd() {
        if(this.lazyImage && this.lazyImage.decode) {
            this.lazyImage.decode().then(() => {
                this.lazyImage.onload = null;
                this.lazyImage = null;

                this.setState({
                    loaded: true,
                    loading: false
                });
            });
        }
        else {
            this.setState({
                loaded: true,
                loading: false
            });
        }
	}

	render() {
		// if(!this.state.loaded) {
		// 	return null;
		// }

		return (
            <div ref={this.props.forwardedRef} className={'lazy-image' + (this.state.loading ? ' loading' : '') + (this.state.loaded ? ' loaded' : '')}>
                {!this.state.loaded && <div className="aspect-ratio-placeholder-fill" style={{paddingBottom: `${(this.props.attrs.height / this.props.attrs.width) * 100}%`}}></div>}
                {/*<img ref={this.placeholder} className="placeholder" src={this.props.attrs.placeholder.src} srcSet={this.props.attrs.placeholder.srcSet} alt=""/>*/}
                {this.state.loaded && <img ref={this.image} className={this.props.attrs.className} src={this.props.attrs.src} srcSet={this.props.attrs.srcSet} sizes={this.props.attrs.sizes} />}
            </div>
        );
	}
};

let WrappedComponent = React.forwardRef((props, ref) => {
	return <LazyImage {...props} forwardedRef={ref} />;
});

export default WrappedComponent;


// WEBPACK FOOTER //
// ./src/components/LazyImage.js